import { CommonModule } from "@angular/common";
import { Component, inject, input } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { LicenseTypes } from "@models/MasterData";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { CodereStyleMoneyComponent } from "@sports-components/codere-style-money/codere-style-money";
import { FreeBetAvailableDepositFbFormatted } from "@sports-pages/ticket/models";
import { SportsFormatOddPipe } from "@sports-pipes/sports.format-odd.pipe";
import { SportsParseMoneyPipe } from "@sports-pipes/sports.parse-money.pipe";

@Component({
  standalone: true,
  selector: "free-bets-available",
  templateUrl: "free-bets-available.component.html",
  styleUrls: ["free-bets-available.component.scss"],
  imports: [
    IonicModule,
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    FormsModule,
    SportsParseMoneyPipe,
    SportsFormatOddPipe,
    CodereStyleMoneyComponent,
  ],
})
export class FreeBetsAvailable {
  activeFB = input.required<FreeBetAvailableDepositFbFormatted[]>();
  licenseType = input.required<boolean>();

  translate = inject(TranslateService);

  LicenseTypes = LicenseTypes;
}
